/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';


import './HomePage.css';
import { LandingPageServe } from '../../services/api/LandingPageServ';

import { setLPDetails } from '../../slices/createLPSlice';
import { setEdit } from '../../slices/authSlice';

const HomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [lpList, setLpList] = useState([]);
  const getLpList = async () => {
    try {
      let params = {
        sort: 'createdAt:desc',
        status: 'published',
        page: 1,
        limit: 10
      };
      let res = await LandingPageServe.index(params);
      setLpList(Array.isArray(res) ? res : (res.data || []));
    } catch (error) {
      console.log(error)
    }

  }

  const handleClick=(item)=>{
    dispatch(setLPDetails(item))
    dispatch(setEdit(false))
    localStorage.setItem('template_name' , item.templateName)
    navigate(`/preview/${item._id}/${item.name}`)
  }

  useEffect( () => {
     getLpList()
  }, []);
  
  return (
    <div>
      <header>
        <h1 className='page-title'>Latest Pages</h1>
      </header>
      <div className="band">
        {lpList?.map((lp, i) => (<div className={`item-${i+1}`}>
          <a onClick={(()=>handleClick(lp))} className="c-card">
            <div className="thumb" style={{ backgroundImage: `url(${lp.thumbnail})` }}></div>
            <article>
              <h1>{lp?.name}</h1>
              <p>{lp.description}</p>
              <span className='publisher-name'>{lp?.createdBy?.name}</span>
            </article>
          </a>
        </div>))}
      </div>
    </div>

  )
}

export default HomePage